import Page from 'component/Page';
import { useState } from 'react';
import { sendPost } from 'util/request';
import { getParams, formatDateAndTime, calculateExpirationTime } from 'util/utils';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { selectCurrentUser } from 'redux/user/user.selector';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import string from 'util/string';
import Table from 'component/Table';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import Urls from 'util/urls';
const headers = [
	string.APP_PC_QUANTITY,
	string.APP_pc_VOLUME,
	string.APP_PC_AMOUNT,
];

const PurchasePrepaid = ({ serviceCodeId = null }) => {
	//-------------------------------HOOKS-------------------------------------------------------------
	const [ page, setPage ] = useState(1);
	const [ total, setTotal ] = useState(0);
	const [ pageSize, setPageSize ] = useState(10);
	const history = useHistory();
	const expirationMinutes = 24 * 60;
	const expirationTime = calculateExpirationTime(expirationMinutes);
	const formattedExpirationTime = formatDateAndTime(expirationTime);
	const [ value, setValue ] = useState(1);
	const [ amount, setAmount ] = useState(1100);
	const [ volume, setVolume ] = useState(50);
	const [ tax, setTax ] = useState(0);
	//------------------------------FUNCTIONS----------------------------------------------------------
	const dataTable = useCallback(() => {
		return [
			{
				data: [
					<input
						type="number"
						value={value}
						onChange={handleChange}
					/>,
					<p>{volume}</p>,
					<p>{amount}</p>,
				]
			},
		];
	}, [ value, amount, volume ]);
	const handleChange = (e) => {
		const newValue = parseInt(e.target.value);
		if (!isNaN(newValue) && newValue >= 0) {
			setValue(newValue);
			setVolume(newValue*50);
			setAmount(newValue * 1100);
		} else {
			setValue(0);
			setVolume(0);
			setAmount(0);
		}
	};
	const handleAssignClick = (e) => {
		history.push(`${Paths.purchase.purchaseAssignId}`);
	};
	const handlePayClick = async () => {
		let data = {
			volume: value,
		};
		const response = await sendPost({
			url: Urls.fincode.redirect,
			body: data,
		})
		const linkUrl = response
		if (linkUrl?.result) {
			window.location.replace(linkUrl?.result);
		}
		return linkUrl;
	};
 const mainActions =  [
		{
			icon: 'pay',
			title: string.APP_PC_PREPAID_PAY,
			onClick: () => handlePayClick(),
		},
		// {
		// 	icon: 'assign',
		// 	title: string.APP_PC_PREPAID_ASSIGN,
		// 	onClick: () => handleAssignClick(),
		// },
  ];

	//-------------------------------RETURN------------------------------------------------------------
	return (
		<>
			<Page
				title={``}
				// title={`${string.APP_PC_TAB_PREPAID_TITLE}`}
				body={
					<>
						<Table
							className="nowrap"
							page={page}
							pageSize={pageSize}
							// total={total}
							onPageChanged={setPage}
							onPageSizeChanged={setPageSize}
							headers={headers}
							data={dataTable(value)}
							isPaging={false}
							mainActions={mainActions}
						/>
						{/* <div className='function-button-area' style={{ marginTop: '15px' }}>
							<Button className="btn" onClick={handleAssignClick}>
									Assign
							</Button>
							<Button className="btn" onClick={handlePayClick}>
									PAY
							</Button>
						</div> */}
					</>
				}
			/>
		</>
	);
};

export default PurchasePrepaid;
